import { render, staticRenderFns } from "./asiakirja-button.vue?vue&type=template&id=0eb0f4c0&"
import script from "./asiakirja-button.vue?vue&type=script&lang=ts&"
export * from "./asiakirja-button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports